import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";

import {
  Headers,
  Logo,
  List,
  Item,
  MenuLink,
  Menu1,
  Menu2,
  Menu3,
  Menu4,
  SubMenuWrapper,
  StyledBurger
} from "./style";

import FontCart from "components/FontCart";
const useCheckBox = () => {
  const [checked, setChecked] = useState(false);
  const onChange = (event) => {
    const {
      target: { checked }
    } = event;
    setChecked(checked);
  }
  return { onChange, checked };
}




const Header = ({ familyname }) => {
  // const [keyword, setKeyword] = useState("");
  // const { push } = useNavigate();
  const { pathname } = useLocation();
  const [shrink, setShrink] = useState(false);

  //console.log(shrink);

  // const searchKeyword = (event) => {
  //   const {
  //     target: { value },
  //   } = event;
  //   setKeyword(value);
  // };

  // const searchFontList = (event) => {
  //   event.preventDefault();
  //   push(`/${keyword}`);
  // };

  // const clearKeyword = (event) => {
  //   setKeyword("");
  // };

  // const selectFamily = (event) => {
  //   switch (event.target.value) {
  //     case "title":
  //       break;
  //     default:
  //       push(`/detail/${event.target.value}`);
  //       break;
  //   }
  // };




  const shrinkHeader = () => {
    var header = document.querySelector("header");
    if (document.body.scrollTop > 0 || document.documentElement.scrollTop > 0) {
      header.classList.add("detailHeader");
      setShrink(true);
    } else {
      header.classList.remove("detailHeader");
      setShrink(false);
    }
  };


  //mobile click button
  const [toggle, setToggle] = useState(false);


  const Burger = ({ toggle, setToggle }) => {
    return (
      <StyledBurger open={toggle} onClick={() => setToggle(!toggle)}>
        <div />
        <div />
        <div />
      </StyledBurger>
    )
  }


  useEffect(() => {
    window.addEventListener("scroll", shrinkHeader);
    return () => window.removeEventListener("scroll", shrinkHeader);
  }, []);

  const detail = pathname.includes("/detail");


  return (
    <Headers detail={detail} className="no-print">


      <a href="/" >
        <Logo />
      </a>

      <SubMenuWrapper>
        <a href="https://www.fontbada.co.kr/information.php">
          <Menu1 />
        </a>
        <a href="/">
          <Menu2 />
        </a>
        <a href="https://www.fontbada.co.kr/download.php">
          <Menu3 />
        </a>
        <a href="https://www.fontbada.co.kr/login.php">
          <Menu4 />
        </a>
      </SubMenuWrapper>



      <List toggle={toggle} >
        <Item current={pathname === "/all"}>
          <MenuLink onClick={() => setToggle(!toggle)} to="/all">ALL</MenuLink>
        </Item>
        <Item current={pathname === "/"}>
          <MenuLink onClick={() => setToggle(!toggle)} to="/">BEST</MenuLink>
        </Item>
        <Item current={pathname === "/gothic"}>
          <MenuLink onClick={() => setToggle(!toggle)} to="/gothic">고딕</MenuLink>
        </Item>
        <Item current={pathname === "/myeongjo"}>
          <MenuLink onClick={() => setToggle(!toggle)} to="/myeongjo">명조</MenuLink>
        </Item>
        <Item current={pathname === "/gulim"}>
          <MenuLink onClick={() => setToggle(!toggle)} to="/gulim">굴림</MenuLink>
        </Item>
        <Item current={pathname === "/design"}>
          <MenuLink onClick={() => setToggle(!toggle)} to="/design">디자인</MenuLink>
        </Item>
        <Item current={pathname === "/fancy"}>
          <MenuLink onClick={() => setToggle(!toggle)} to="/fancy">팬시</MenuLink>
        </Item>
        <Item current={pathname === "/handwriting"}>
          <MenuLink onClick={() => setToggle(!toggle)} to="/handwriting">손글씨</MenuLink>
        </Item>

        <Item current={pathname === "/retro"}>
          <MenuLink onClick={() => setToggle(!toggle)} to="/retro">옛글씨</MenuLink>
        </Item>

        <Item current={pathname === "/headline"}>
          <MenuLink onClick={() => setToggle(!toggle)} to="/headline">헤드라인</MenuLink>
        </Item>
      </List>

      <Burger toggle={toggle} setToggle={setToggle} />


    </Headers >
  );
};

export default Header;
